const CARD_TYPES = {
  misses: 'Ms',
  mister: 'Mr',
  female: 'female',
  male: 'male',
  moral: 'moral',
}

const NODE_STATES = {
  normal: 'normal',
  current: 'current',
}

export { CARD_TYPES, NODE_STATES }
